<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch6" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT"><span aria-label="8" id="pg_8" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch6" id="ch6" title="Link target outside of Sample"><b><i>Cleansing</i></b></span></span></h1>
</header>
<blockquote>
<p class="VSB">I know my worth … now.</p>
<p class="V">My therapy sessions are paying off. There was</p>
<p class="V">a time when I did not think I was worth two</p>
<p class="VSB">corroded pennies rubbed together.</p>
<p class="VSB">My therapist claims this is normal.</p>
<p class="V">But, if I had to pinpoint a time</p>
<p class="V">in my life when I felt as worthless</p>
<p class="VSB">and as meaningless as hot dog scum—</p>
<p class="V"><i>yes, it’s real stuff</i>—it would be the awakening</p>
<p class="V">my <i>twenty-something-year-old-self</i></p>
<p class="V">had while scrubbing 30-year-old, once-white</p>
<p class="VSB">bathroom tile grout with a nail file at 3 a.m.</p>
<p class="V">While the babies and my husband slept, I</p>
<p class="V">labored over the most ridiculous of tasks,</p>
<p class="V">trying in vain to make</p>
<p class="V">our helter-skelter lives pristine, Mayberryish</p>
<p class="VSB">and fairytale like.</p>
<p class="V">I thought that bleach, Pine Sol,</p>
<p class="V">and elbow grease could wash the pain away,</p>
<p class="VSB">send the misery gurgling down the drain.</p>
<p class="V">In some twisted way, I hoped</p>
<p class="V">the cleanliness I tried to impart</p>
<p class="V">would wash the filth away from my soiled soul.</p>
<p class="V">I felt dirty … and used. Spoiled goods.</p>
<p class="V"><span aria-label="9" id="pg_9" role="doc-pagebreak">I was dependent upon a man for my emotional</span></p>
<p class="VSB">and physical stability.</p>
<p class="VSB">My lot in life was to please him, not rile him.</p>
<p class="V">Please him: always my thoughts were of</p>
<p class="VSB">pleasing him.</p>
<p class="VSB">Make him happy. Keep him calm.</p>
<p class="V"><i>The kids don’t need to hear him angry. He will</i></p>
<p class="V"><i>ignore them if he’s mad at me.</i> He likes the</p>
<p class="VSB">house clean.</p>
<p class="VSB">Clean … makes him … tolerable.</p>
<p class="V">The carpets require vacuum marks—just so.</p>
<p class="VSB">One direction. Unified. Back and forth.</p>
<p class="V">The bathroom should be immaculate. Wash and</p>
<p class="VSB">shine shampoo bottles.</p>
<p class="V">Fold the towels just right. Creases left</p>
<p class="VSB">and right.</p>
<p class="VSB">The tile must glow. The grout is old …</p>
<p class="V">my fingers are raw and peeling. Droplets of</p>
<p class="V">my blood are on the canvas. The bleach</p>
<p class="VSB">burns … but scour, I will.</p>
<p class="V">I must prove to this man who thinks I’m</p>
<p class="V">nothing that I have worth.</p>
<p class="VSB"><span aria-label="10" id="pg_10" role="doc-pagebreak">I must justify my worthiness to myself.</span></p>
<p class="V">So, as I sat there on that cold tile, inhaling</p>
<p class="VSB">bleach fumes, scrubbing</p>
<p class="V">with bleeding fingers, <i>and hating myself all</i></p>
<p class="V"><i>the while, knowing that my life was a</i></p>
<p class="VSB"><i>delusional screwed-up mess.</i></p>
<p class="VSB">I had an awakening.</p>
<p class="V">I did not want to feel worthless anymore.</p>
<p class="VSB">I wanted it all to go away.</p>
<p class="VSB">I wanted to start a new life. Begin again.</p>
<p class="VSB">Blink and make it all go away.</p>
<p class="V">Little did I know, it would take hundreds of</p>
<p class="V">these self-awakening cleaning sprees before</p>
<p class="VSB">I acquired the strength</p>
<p class="V">to shake out my fearful feathers, and fly.</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter6.vue?aae373be